/**
 * TitleParagraphComponent is a React functional component that displays a title and a paragraph.
 * The title can have specific words highlighted based on the provided indices and background colors.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.title - The title text to be displayed.
 * @param {string} props.paragraph - The paragraph text to be displayed.
 * @param {number[]} props.highlightIndicesList - An array of indices indicating which words in the title should be highlighted.
 * @param {string[]} props.highlightBgList - An array of background colors corresponding to the highlight indices.
 * @returns {JSX.Element} The rendered TitleParagraphComponent.
 */
import React from 'react';
import HighlightWordsComponent from '../HighlightWordsComponent/HighlightWordsComponent.tsx';
import { TitleParagraphComponentProps } from '../../constants/interface.ts';

const TitleParagraphComponent = (props : TitleParagraphComponentProps) => {
    const { title, paragraph, highlightList, } = props;

    return (
        <div className="grid gap-3 text-center m-auto lg:gap-8">
            <HighlightWordsComponent
                sentence={title.text}
                className={`text-3xl font-medium lg:text-6xl lg:font-bold m-auto ${title.className || ''}`}
                style={{}}
                highlightList={highlightList}
            />
            <>
            {
                paragraph.text && (
                    <p className={`text-base font-medium lg:text-lg lg:font-normal m-auto ${paragraph.className || ''}`}>{paragraph.text}</p>
                )
            }
            </>
        </div>
    );
};

export default TitleParagraphComponent;